<template>
	<div>
		<v-btn depressed small class="shades white black--text connect-eoloquence-banner__cta" @click="requestExchangeUser">
			Essayer maintenant !
		</v-btn>
		<v-dialog v-model="dialog" max-width="420" content-class="eloq-dialog">
			<v-card class="eloq-card" elevation="8">
				<v-card-title class="eloq-title">
					<span>Ouvrir Eloquence</span>
				</v-card-title>

				<v-card-text class="eloq-text">
					<p class="eloq-text__primary">Vous allez ouvrir Eloquence dans un nouvel onglet.</p>
				</v-card-text>

				<v-card-actions class="eloq-actions">
					<v-btn text color="grey darken-1" @click="closeDialog">Annuler</v-btn>
					<v-btn
						:disabled="!exchangeUserUrl"
						:href="exchangeUserUrl"
						target="_blank"
						rel="noopener"
						dark
						color="black"
						depressed
						@click="closeDialog"
					>
						Continuer
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from 'axios';

const ELEOQUENCE_URL = process.env.VUE_APP_ELOQUENCE_URL || '';

export default {
	name: 'LoginToEloquenceBtn',
	props: {
		userId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			exchangeUserUrl: null,
			dialog: false,
		};
	},
	methods: {
		async requestExchangeUser() {
			const response = await axios.post('/api/connect-eoloquence/request-exchange-user', { userId: this.userId });
			const token = response.data.token;
			this.exchangeUserUrl = `${ELEOQUENCE_URL}/handle-exchange-user?token=${token}&utm_source=orthographiq`;
			this.dialog = true;
		},
		closeDialog() {
			this.dialog = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.eloq-card {
	border-radius: 12px;
}

.eloq-title {
	align-items: center;
	gap: 8px;
	font-weight: 600;
	letter-spacing: 0.2px;
}

.eloq-text {
	padding-top: 14px;
}

.eloq-text__primary {
	margin: 0;
	font-size: 14px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.78);
}

.eloq-text__secondary {
	margin: 8px 0 0;
	font-size: 13px;
	line-height: 1.45;
	color: rgba(0, 0, 0, 0.6);
}

.eloq-actions {
	display: flex;
	justify-content: flex-end;
	padding: 12px 16px 16px;
}

.connect-eoloquence-banner__cta {
	flex-shrink: 0;
}
</style>
